import { usersListResponse } from "types/userInfo";
import { genericGet, genericPost } from "./base.api";
import { getDataApiUrl } from "utils/utils";

export function GetUsers(params?: Record<string, any>): Promise<usersListResponse> {
  return genericGet(`${getDataApiUrl()}/localized/users`, params)
  // return Promise.resolve({
  //   "items": [
  //     {
  //       "user_id": "_6bd675d5-4410-5aae-81f9-1a16e5d6df68",
  //       "location": {
  //         "venue": {
  //           "id": "074e6a47-bf11-4178-af05-89e2bd75c85b",
  //           "name": "naveniostaldates"
  //         },
  //         "region": null,
  //         "coordinates": {
  //           "latitude": 51.795662,
  //           "longitude": -1.466924
  //         },
  //         "uncertainty": {
  //           "source": "10.0",
  //           "parsedValue": 10
  //         },
  //         "is_outdoors": true
  //       },
  //       "last_update_timestamp": "2025-08-13T09:56:26.808000Z",
  //       "session": {
  //         "session_id": "6df19456-43b0-457d-9d88-abdf4a054d50",
  //         "expiration_timestamp": "2025-08-14T09:56:26.808000Z",
  //         "creation_timestamp": "2025-08-13T09:56:26.808000Z"
  //       },
  //       "name": "Navenio 2",
  //       "email": "example@test.com"
  //     },
  //     {
  //       "user_id": "_f135a462-1997-5612-860b-81ef33a26095",
  //       "location": {
  //         "venue": {
  //           "id": "074e6a47-bf11-4178-af05-89e2bd75c85b",
  //           "name": "naveniostaldates"
  //         },
  //         "region": null,
  //         "coordinates": {
  //           "latitude": 51.7956748,
  //           "longitude": -1.4669517
  //         },
  //         "uncertainty": {
  //           "source": "10.0",
  //           "parsedValue": 10
  //         },
  //         "is_outdoors": true
  //       },
  //       "last_update_timestamp": "2025-08-13T09:04:59.849000Z",
  //       "session": {
  //         "session_id": "a207dbf3-623d-42d3-82e3-749f5c28b09a",
  //         "expiration_timestamp": "2025-08-14T09:04:34.465000Z",
  //         "creation_timestamp": "2025-08-13T09:04:34.465000Z"
  //       },
  //       "name": "Navenio 1",
  //       "email": null
  //     }
  //   ],
  //   "next": null,
  //   "count": 2,
  //   "total": 2
  // })
}

export function CreateExportJob(start_date: string, end_date: string): Promise<{ job_id: string }> {
  const queryString = new URLSearchParams();
  queryString.append('start_date', start_date);
  queryString.append('end_date', end_date);
  return genericPost(`${getDataApiUrl()}/event/change/user/export/job?${queryString.toString()}`, null)
};

export function GetExportJobStatus(jobId: string | null): Promise<any> {
  return genericGet(`${getDataApiUrl()}/event/change/user/export/job/${jobId}/status`)
};